module.exports = __webpack_public_path__ + "static/media/data-analyst-feature-tile-icon-01.72356c08.svg";